export const DEFAULT_LOCALE = "it";

export const FALLBACK_LOCALE = "it";

export const SUPPORTED_LOCALES = [
  {
    code: "it",
    label: "Italiano",
    flag: "it"
  },
  {
    code: "de",
    label: "Deutsch",
    flag: "de"
  }
];
